export { default } from './ChangeMarketingApproval.container';
